import { render, staticRenderFns } from "./check-icon.vue?vue&type=template&id=58c7fa20&scoped=true"
import script from "./check-icon.vue?vue&type=script&lang=ts"
export * from "./check-icon.vue?vue&type=script&lang=ts"
import style0 from "./check-icon.vue?vue&type=style&index=0&id=58c7fa20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7fa20",
  null
  
)

export default component.exports